import { LOCATION_CHANGE, replace } from 'connected-react-router'
import * as R from 'ramda'
import { ofType } from 'redux-observable'
import { empty, of } from 'rxjs'
import { delayWhen, filter, switchMap } from 'rxjs/operators'
import { VIEWPORTS } from 'constants/screenSize'
import { getNewMediaQueries } from 'domain/screenSize'
import { equalsResource } from 'domain/resources'
import { isCatalogOrUniverseOrSaleSlugPageAction, hasNoCypher } from 'domain/router'
import * as Actions from 'store/actions/index.ts'
import {
  getAllProductsUrl,
  getCurrentResource,
  getFirstProductRedirectUri,
  getFirstSubUniverseWithProducts,
  getfirstSubUniverseWithProductsUrl,
  getHasOneProduct,
  getHasOnlyOneUniverse,
  getIsResourceFetched,
  getIsViewAllOffersFeatureEnabled,
  getResourceHasProducts,
  getSaleHomePageUrl,
  getSaleResource
} from 'store/selectors'

const getStateValue = (state$) => () => R.prop('value', state$)

const redirectTo = (state) => {
  const hasOneProduct = getHasOneProduct(state)
  const hasMultipleUniverses = !getHasOnlyOneUniverse(state)
  const currentResource = getCurrentResource(state)
  const sale = getSaleResource(state)
  const isOnSaleRoute = equalsResource(currentResource, sale)
  const firstSubUniverseWithProducts = getFirstSubUniverseWithProducts(state)
  const hasNoProducts = !getResourceHasProducts(state)
  const screenSize = getNewMediaQueries(VIEWPORTS)
  const isViewAllOffersFeatureEnabled = getIsViewAllOffersFeatureEnabled(state)

  if (hasOneProduct) { return replace(getFirstProductRedirectUri(state)) }

  if (hasMultipleUniverses && isOnSaleRoute && !screenSize.large) {
    return replace(getSaleHomePageUrl(state))
  }

  if (hasMultipleUniverses && isOnSaleRoute && isViewAllOffersFeatureEnabled) {
    return replace(getAllProductsUrl(state))
  }

  if (firstSubUniverseWithProducts && (
    (hasMultipleUniverses && hasNoProducts) || isOnSaleRoute
  )) {
    return replace(getfirstSubUniverseWithProductsUrl(state))
  }

  return null
}

const OffersEpic = (actions$, state$) => actions$.pipe(
  ofType(LOCATION_CHANGE),
  filter(R.both(
    isCatalogOrUniverseOrSaleSlugPageAction,
    hasNoCypher
  )),
  delayWhen(() => {
    const state = state$.value
    const isSaleFetchedAction = (action) => ( // (action: ResourceFetchedAction)
      action.payload.type === 'sale'
    )

    if (getIsResourceFetched(state) && getSaleResource(state)) { return of({}) }

    return actions$.pipe(
      ofType(Actions.resources.RESOURCE_FETCHED),
      filter(isSaleFetchedAction)
    )
  }),
  switchMap(
    R.pipe(
      getStateValue(state$),
      redirectTo,
      R.ifElse(
        R.isNil,
        empty,
        of
      )
    )
  )
)

export default OffersEpic
